// src/components/CustomCursor.tsx - NATIVO CORPORATIVO
const CustomCursor = () => {
  return null; // Usa cursor nativo do browser
};

export default CustomCursor;